<ion-content>
  <ion-header>
    <ion-toolbar>
      <ion-title>{{ authenticator.user.username }}'s Mix Tapes</ion-title>
      <ion-buttons slot="end">
        <ion-button (click)="cancel()" [strong]="true">Close<ion-icon name="close"></ion-icon></ion-button>
      </ion-buttons>
    </ion-toolbar>
  </ion-header>
  <ion-list>
    <div (click)="uploadAudioClicked()" class="button-wrapper">
      <ion-button [disabled]="!isMainScene">
        <ion-label>Upload Audio</ion-label>
        <ion-icon name="recording-outline" slot="end"></ion-icon>
      </ion-button>
    </div>
  </ion-list>
  <ion-grid>
    <ion-row>
      <ion-col size="6" *ngFor="let audio of audio$ | async; index as position">
        <app-audio-container [privateDisplay]="true" [audio]="audio"></app-audio-container>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>